import { LuciusLogo } from '../Custom/Logo/LuciusLogo';
import { LogoIcon } from '../SvgIcons/LogoIcon';

const SideBarHeader = () => {
  return (
    <div
      className="sidebar-header hidden lg:flex items-center relative justify-between px-3 lg:px-6 shrink-0"
      id="sidebar_header"
    >
      <div>
        <LuciusLogo
          containerClassName="default-logo"
          logoIconClassName="dark-mode:[&>path:nth-child(2)]:fill-white dark-mode:[&>g[clip-path]>path:nth-child(2)]:fill-white"
        />
        <LogoIcon
          className="small-logo w-[32.85px] h-auto dark-mode:[&>path:nth-child(2)]:fill-white"
          circleGradientId="paint0_linear_small_logo"
        />
      </div>
      <button
        className="btn btn-icon btn-icon-md size-[30px] rounded-lg border border-gray-200 bg-white shadow-xl text-gray-500 hover:text-gray-700 toggle absolute left-full top-2/4 -translate-x-2/4 -translate-y-2/4 dark-mode:bg-coal-600 dark-mode:border-slate-600"
        data-toggle="body"
        data-toggle-class="sidebar-collapse"
        id="sidebar_toggle"
      >
        <i className="ki-filled ki-left text-gray-99A1B6 toggle-active:rotate-180 transition-all duration-300"></i>
      </button>
    </div>
  );
};

export default SideBarHeader;
